(function(){
function applySale(){
  // Find every compare-at-price anywhere, walk up to find the nearest parent that also contains the ATC button
  var cmps=document.querySelectorAll('.compare-at-price, s, del');
  for(var i=0;i<cmps.length;i++){
    var node=cmps[i];
    // Walk up up to 8 levels looking for a container that also has an ATC button
    var p=node.parentElement,levels=0;
    while(p&&levels<10){
      var btn=p.querySelector('.product-card-actions__button--cart, button[type="submit"].button-primary, button[ref="addToCartButton"]');
      if(btn){
        btn.style.setProperty('background','linear-gradient(135deg,#F95523 0%,#ff6b9d 100%)','important');
        btn.style.setProperty('background-image','linear-gradient(135deg,#F95523 0%,#ff6b9d 100%)','important');
        btn.style.setProperty('background-color','#F95523','important');
        btn.style.setProperty('color','#fff','important');
        btn.style.setProperty('border-color','transparent','important');
        break;
      }
      p=p.parentElement;levels++;
    }
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',applySale);else applySale();
document.addEventListener('shopify:section:load',applySale);
setInterval(applySale,1500);
})();